module.exports = __webpack_public_path__ + "static/media/product3.3fa9b6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/product3.png
// module id = 528
// module chunks = 0